import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import moduleRegistry from '@/configuration/module-registry.js';
import flatten from 'lodash/flatten';
import router from '@/router/index.js';

// component modules
import errorNotificationStore from "@/components/alert_components/error/error-notification-store"
import presetStore from "@/components/base_components/tables/preset/preset_picker/presets-store";

// modules
import actingUser from "./modules/acting-user";
import configuration from "./modules/configuration";
import defaultPrinters from "./modules/default-printers";
import globalSnackbarStore from "../components/global_components/snackbar/global-snackbar-store";
import badgeCounter from "./modules/badge-counter";
import routingHistory from "./modules/routing-history";
import tableStore from "@/components/base_components/tables/store/table-store";
import globalEventListeners from "./modules/global-event-listeners";
import registries from "./modules/registries";
import mobileWrapperTasks from "./modules/mobile-wrapper-tasks";
import updateListeners from "./modules/update-listeners";
import navigationDrawer from "./modules/navigation-drawer";
import sidebarDrawer from './modules/sidebar-drawer';
import websocket from './modules/websocket';

Vue.use(Vuex);

export const plugins = [
    createPersistedState({
        key: 'vuex',
        paths: [
            'activeModule',
            'actingUser',
            'configuration',
            'badgeCounter',
            'defaultPrinters',
            'routingHistory',
            'tableStore',
            'presetStore',
            'globalEventListeners',
            'mobileWrapperTasks',
            'registries',
            'updateListeners',
            'navigationDrawer',
            'sidebarDrawer',
            'websocket'
        ],
        storage: window.sessionStorage,
    }),
];

export const state = {
    activeModule: {
        name: '',
        isSearchable: false,
        isWindow: false,
        furtherInformations: {},
        subtitle: '',
    },
};

export const modules = {
    actingUser,
    configuration,
    defaultPrinters,
    globalSnackbarStore,
    badgeCounter,
    routingHistory,
    errorNotificationStore,
    presetStore,
    tableStore,
    globalEventListeners,
    registries,
    mobileWrapperTasks,
    updateListeners,
    navigationDrawer,
    sidebarDrawer,
    websocket
};

export const mutations = {
    setActiveModule(state, module) {
        const moduleId = router.currentRoute.meta.moduleId;

        let furtherInformations = state.activeModule.furtherInformations;
        if (moduleId == undefined) {
            furtherInformations = {}
        } else if (moduleId !== furtherInformations?.id) {
            furtherInformations = flatten(
                moduleRegistry.tree.map((i) => i.children)
            ).find((element) => element.id === moduleId);

            if (furtherInformations === undefined) {
                window.console.error(`no module entry found for moduleId: ${moduleId}`);
            }
        }

        state.activeModule = { ...module, furtherInformations: furtherInformations ?? {} };
    },
    setActiveModuleName(state, name) {
        Vue.set(state.activeModule,'name', name);
    },
    setActiveModuleSubtitle(state, subtitle) {
        Vue.set(state.activeModule,'subtitle', subtitle);
    },
    setActiveModuleSearchable(state, isSearchable) {
        Vue.set(state.activeModule, 'isSearchable', isSearchable);
    }
};

export const getters = {
    getName: state => {
        return state.activeModule.name;
    },
    getSubtitle: state => {
        return state.activeModule.subtitle;
    },
};
const store = new Vuex.Store({
        getters: getters,
        modules: modules,
        mutations: mutations,
        state: state, 
        plugins: plugins,
    });

export default store;
